import { render, staticRenderFns } from "./ParticipantView.vue?vue&type=template&id=084ba103&scoped=true&"
import script from "./ParticipantView.vue?vue&type=script&lang=js&"
export * from "./ParticipantView.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantView.vue?vue&type=style&index=0&id=084ba103&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ba103",
  null
  
)

export default component.exports